exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-context-menu {\n  position: absolute;\n  z-index: 9997;\n  background-color: white;\n  box-shadow: 3px 2px 5px gray;\n  border-radius: 5px;\n}\n.fm-context-menu:focus {\n  outline: none;\n}\n.fm-context-menu .list-unstyled {\n  margin-bottom: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n.fm-context-menu ul > li {\n  padding: 0.4rem 1rem;\n}\n.fm-context-menu ul > li:not(.disabled) {\n  cursor: pointer;\n}\n.fm-context-menu ul > li:not(.disabled):hover {\n  background-color: #f8f9fa;\n}\n.fm-context-menu ul > li:not(.disabled) i {\n  padding-right: 2rem;\n}", ""]);

// exports
